// Responsive Breakpoints
import { useMediaQuery } from "react-responsive";

export const Breakpoints = {
  isMobile: 768,
  isTabletOrMobile: 1024,
  isDesktop: 1025,
  isDesktopLarge: 1366,
  isMobileMini: 360,
  isDesktopExtraLarge: 1599,
  isMobileMiniDown: 359,
};

// Mobile Devies Only
export const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

export const Mobile768 = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return isMobile ? children : null;
};

// Small Tablets in Portrait Mode Only
export const TabletDown = ({ children }) => {
  const isTablet = useMediaQuery({ maxWidth: 1024 });
  return isTablet ? children : null;
};

// Small Tablets in Portrait Mode Only
export const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1024 });
  return isTablet ? children : null;
};

// Small Tablets in Portrait Mode and Up
export const TabletUp = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 768 });
  return isTablet ? children : null;
};

export const DesktopDown = ({ children }) => {
  const isDesktop = useMediaQuery({ maxWidth: 1024 });
  return isDesktop ? children : null;
};
export const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1025 });
  return isDesktop ? children : null;
};
export const DesktopUp = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  return isDesktop ? children : null;
};
export const DesktopLargeDown = ({ children }) => {
  const isDesktopLargeDown = useMediaQuery({ maxWidth: 1365 });
  return isDesktopLargeDown ? children : null;
};
export const DesktopLarge = ({ children }) => {
  const isDesktopLarge = useMediaQuery({ minWidth: 1366 });
  return isDesktopLarge ? children : null;
};

export const MobileMini = ({ children }) => {
  const isMobileMini = useMediaQuery({ maxWidth: 360 });
  return isMobileMini ? children : null;
};
export const MobileMiniDown = ({ children }) => {
  const isMobileMiniDown = useMediaQuery({ maxWidth: 360 });
  return isMobileMiniDown ? children : null;
};

export const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1366px",
  desktop: "1920px",
  desktopL: "2560px",
};

export const device = {
  mobileS: `min-width: ${size.mobileS}`,
  mobileM: `min-width: ${size.mobileM}`,
  mobileL: `min-width: ${size.mobileL}`,
  tablet: `min-width: ${size.tablet}`,
  laptop: `min-width: ${size.laptop}`,
  laptopL: `min-width: ${size.laptopL}`,
  desktop: `min-width: ${size.desktop}`,
  desktopL: `min-width: ${size.desktopL}`,
};

export const toRem = (px) => {
  return `${px / 16}rem`;
};
